import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg z-[45]">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm">
            {t('legal.cookies.banner.message')}{' '}
            <Link to="/privacy-policy" className="underline hover:text-white/80">
              {t('legal.cookies.banner.privacyLink')}
            </Link>
            {' '}{t('common.and')}{' '}
            <Link to="/terms" className="underline hover:text-white/80">
              {t('legal.cookies.banner.termsLink')}
            </Link>
            .
          </p>
        </div>
        <div className="flex gap-3">
          <Button
            variant="outline"
            size="sm"
            onClick={handleDecline}
            className="bg-transparent border-white text-white hover:bg-white hover:text-gray-900"
          >
            {t('legal.cookies.banner.decline')}
          </Button>
          <Button
            size="sm"
            onClick={handleAccept}
            className="bg-primary hover:bg-primary/90 text-white"
          >
            {t('legal.cookies.banner.accept')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;